import { useId } from "react";

import { cn } from "@/lib/utils";

export function BuildingIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-13 w-19.5", className)}
      viewBox="0 0 78 52"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.42662 34.9423L1.42663 33.5399L49.4368 17.7621L77.3098 33.9811L77.3098 35.3767L29.2997 52.5569L1.42662 34.9423Z"
        fill={`url(#paint0_linear_${id})`}
      />
      <mask
        height="36"
        id={`mask0_${id}`}
        maskUnits="userSpaceOnUse"
        width="77"
        x="1"
        y="16"
      >
        <rect
          fill={`url(#paint1_linear_${id})`}
          height="35.2618"
          transform="matrix(0.967417 -0.346185 0.790462 0.49954 1.3916 33.5)"
          width="49.6271"
        />
      </mask>
      <g mask={`url(#mask0_${id})`}>
        <rect
          fill={`url(#paint2_linear_${id})`}
          height="35.2618"
          transform="matrix(0.967417 -0.346185 0.790462 0.49954 1.3916 33.5)"
          width="49.6271"
        />
        <path
          clipRule="evenodd"
          d="M18.3239 44.2027L16.8618 43.2787L26.6324 36.3237L8.6586 33.6347C8.22144 33.5693 7.92008 33.1619 7.98548 32.7247C8.05088 32.2876 8.45828 31.9862 8.89544 32.0516L28.5112 34.9863L37.13 28.8512C37.4901 28.5949 37.9898 28.679 38.2461 29.0391C38.5025 29.3992 38.4183 29.8989 38.0582 30.1553L30.7921 35.3275L43.4542 37.2219L47.5636 31.4666L35.4015 25.4334C35.0926 25.5138 34.7522 25.4037 34.5528 25.1301C34.515 25.0782 34.4844 25.0234 34.4607 24.9667L30.5992 23.0511L32.6917 22.3023L35.2992 23.5958L41.3014 19.2214L44.8456 17.9531C44.9423 18.2702 44.8343 18.6273 44.5512 18.8336L36.9162 24.398L48.9637 30.3743L72.2642 30.7701L74.8664 32.4147L49.1706 31.9706L45.2313 37.4878L60.5882 39.7853C60.6562 39.7955 60.7209 39.8139 60.7814 39.8394L57.6417 40.963L44.1871 38.9501L37.6391 48.1208L35.0012 49.0647C35.0119 49.047 35.0234 49.0296 35.0356 49.0124L38.2066 44.5713L23.515 40.5075L18.3239 44.2027ZM28.9132 36.6649L42.4101 38.6842L39.1969 43.1844L25.1953 39.3115L28.9132 36.6649Z"
          fill="white"
          fillRule="evenodd"
          opacity="0.5"
        />
        <path
          d="M39.0997 61.5746L24.8975 41.1018L49.9008 25.4883L84.9248 38.4113L39.0997 61.5746Z"
          fill={`url(#paint3_linear_${id})`}
          opacity="0.3"
        />
      </g>
      <path
        d="M64.2259 34.6969C64.2603 35.359 62.8568 35.9701 61.0911 36.0618C59.3254 36.1535 57.8662 35.6911 57.8318 35.029C57.7974 34.3668 59.2009 33.7557 60.9666 33.664C62.7323 33.5723 64.1915 34.0347 64.2259 34.6969Z"
        fill="white"
        opacity="0.23"
      />
      <path
        d="M28.5511 30.0445C28.5855 30.7067 27.182 31.3178 25.4163 31.4095C23.6506 31.5012 22.1914 31.0388 22.157 30.3766C22.1226 29.7145 23.5261 29.1034 25.2918 29.0117C27.0575 28.92 28.5167 29.3824 28.5511 30.0445Z"
        fill="white"
        opacity="0.23"
      />
      <path
        d="M32.5775 45.525C32.6119 46.1871 31.2084 46.7983 29.4427 46.89C27.677 46.9817 26.2178 46.5192 26.1834 45.8571C26.149 45.195 27.5525 44.5839 29.3182 44.4922C31.0839 44.4004 32.5431 44.8629 32.5775 45.525Z"
        fill="white"
        opacity="0.23"
      />
      <path
        d="M13.5674 33.2978L33.4764 45.0753L59.7595 34.8522V19.4231L37.9463 7.9668L13.5674 16.7789V33.2978Z"
        fill={`url(#paint4_linear_${id})`}
      />
      <path
        d="M33.4516 45.0663V28.5016L13.5635 16.6504V33.3022L33.4516 45.0663Z"
        fill={`url(#paint5_linear_${id})`}
      />
      <path
        d="M30.7101 42.7306V31.797L17.5829 23.9746L16.0146 24.8192L17.5829 34.9656L29.1457 43.7456L30.7101 42.7306Z"
        fill="#ADEAFF"
      />
      <path
        d="M29.0986 32.904L30.7526 31.8672V42.7535L29.0986 43.76V32.904Z"
        fill="#4FAFD0"
      />
      <path
        d="M29.1721 43.7677V32.8341L16.0449 25.0117V36.0028L29.1721 43.7677Z"
        fill="#557AFF"
      />
      <path
        d="M54.4067 21.2793L36.3232 27.5817V43.9941L37.9746 44.6224L54.4067 36.9503V21.2793Z"
        fill="#4FAFD0"
      />
      <path
        d="M56.0737 21.8359L37.9902 28.1384V44.5508L56.0737 37.5069V21.8359Z"
        fill={`url(#paint6_linear_${id})`}
      />
      <path
        clipRule="evenodd"
        d="M13.6074 16.6609L33.4524 28.5713L36.4788 27.5201L38.0288 28.1866L56.1734 21.8577L54.4547 21.276L59.7644 19.4316L37.9473 7.88672L13.6074 16.6609Z"
        fill="white"
        fillRule="evenodd"
      />
      <path
        d="M15.8545 16.848L33.5032 27.4403L36.1935 26.5058L37.5726 27.0988L53.7092 21.4704L52.18 20.9528L56.9032 19.3121L37.5007 9.04492L15.8545 16.848Z"
        fill="#586DFF"
      />
      <path
        d="M32.5055 23.9754L23.1555 18.3971L23.1553 16.545L37.8349 13.168L48.1694 16.5046V18.6367L32.5055 23.9754Z"
        fill="#ADEAFF"
      />
      <path
        d="M32.5052 21.8477L23.1553 16.4889L37.8346 11.2598L48.1691 16.509L32.5052 21.8477Z"
        fill="white"
      />
      <path
        clipRule="evenodd"
        d="M41.0261 9.25087C41.0261 6.09397 38.8077 2.25449 36.0774 0.676043C34.5986 -0.178925 33.2574 -0.195319 32.3386 0.470937L29.9814 1.99218C30.2497 2.07161 30.6625 2.23398 31.1785 2.49227C31.1179 2.81214 31.0861 3.16004 31.0861 3.53432C31.0861 3.82953 31.0795 4.1324 31.0728 4.44145C31.0418 5.8706 31.0078 7.43186 31.6086 8.97897C32.8422 12.156 35.1781 15.146 35.8546 16.012C35.951 16.1354 35.556 16.6057 35.577 16.6372C36.0348 16.3169 41.0261 13.4573 41.0261 9.25087ZM34.0515 4.34086C33.8747 4.60723 33.7737 4.96936 33.7737 5.4114C33.7737 6.86187 34.7976 8.61096 36.0348 9.3362C36.4095 9.55587 36.7647 9.65421 37.0778 9.64544C37.0636 8.17421 36.6844 6.72903 35.6185 5.70413C35.0854 5.19158 34.5585 4.73859 34.0515 4.34086Z"
        fill={`url(#paint7_linear_${id})`}
        fillRule="evenodd"
      />
      <path
        d="M33.7784 2.16628C36.5087 3.74473 38.7271 7.58421 38.7271 10.7411C38.7271 15.6471 33.9917 17.6522 33.7358 17.7375C33.4798 17.3535 28.7871 9.88789 28.7871 5.02455C28.7871 1.86765 31.0481 0.587826 33.7784 2.16628ZM33.7358 10.8264C34.9729 11.5517 35.9968 10.9544 35.9968 9.54661C35.9968 8.1388 34.9729 6.34704 33.7358 5.62181C32.4986 4.89657 31.4747 5.49382 31.4747 6.90163C31.4747 8.3521 32.4986 10.1012 33.7358 10.8264Z"
        fill={`url(#paint8_linear_${id})`}
      />
      <path
        d="M32.542 21.8004V23.9757L48.2307 18.6033V16.4609L32.542 21.8004Z"
        fill="#4FAFD0"
      />
      <path
        d="M45.9082 35.7775V41.4532L50.5535 39.5493V34.0293L45.9082 35.7775Z"
        fill="#4E5DD3"
      />
      <path d="M48.2295 34.9961V40.4863" stroke="white" strokeWidth="0.4" />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint0_linear_${id}`}
          x1="75.3417"
          x2="5.04715"
          y1="32.0719"
          y2="49.0395"
        >
          <stop stopColor="#CEA8FF" />
          <stop offset="1" stopColor="#8F5DE0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint1_linear_${id}`}
          x1="60.7579"
          x2="22.0918"
          y1="-4.83647"
          y2="-32.1067"
        >
          <stop stopColor="#AB7CE7" />
          <stop offset="1" stopColor="#6533B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint2_linear_${id}`}
          x1="60.7579"
          x2="22.0918"
          y1="-4.83647"
          y2="-32.1067"
        >
          <stop stopColor="#AB7CE7" />
          <stop offset="1" stopColor="#6533B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint3_linear_${id}`}
          x1="49.1229"
          x2="78.0645"
          y1="36.9889"
          y2="70.3399"
        >
          <stop stopColor="#0E0077" />
          <stop offset="1" stop-opacity="0" stopColor="#0E0077" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint4_linear_${id}`}
          x1="48.36"
          x2="5.40364"
          y1="67.3893"
          y2="55.5898"
        >
          <stop stopColor="#586AFF" />
          <stop offset="1" stopColor="#43C9FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint5_linear_${id}`}
          x1="36.9641"
          x2="19.8548"
          y1="56.1759"
          y2="60.1483"
        >
          <stop stopColor="#586AFF" />
          <stop offset="1" stopColor="#43C9FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint6_linear_${id}`}
          x1="65.548"
          x2="31.8729"
          y1="24.4593"
          y2="41.1553"
        >
          <stop stopColor="#4FAFD0" />
          <stop offset="1" stopColor="#557AFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint7_linear_${id}`}
          x1="39.8554"
          x2="26.6748"
          y1="20.3082"
          y2="17.3265"
        >
          <stop stopColor="#E27CBC" />
          <stop offset="1" stopColor="#D494DE" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint8_linear_${id}`}
          x1="38.7271"
          x2="22.5445"
          y1="24.1437"
          y2="20.4898"
        >
          <stop stopColor="#C1348C" />
          <stop offset="1" stopColor="#9432A4" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function WavesIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-25 w-120.5", className)}
      fill="none"
      viewBox="0 0 482 100"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M99.688 -35H31.5867C39.9952 -0.398792 -0.351349 25.4055 -39.3975 50.3782C-41.0427 51.4304 -42.6856 52.4812 -44.3225 53.531C-69.9752 69.686 -94.1786 85.6093 -106 103.47V149.633C-104.406 152.155 -102.542 154.723 -100.392 157.342C-89.1791 171.358 -69.9787 183.751 -49.3491 196H12.134C-9.42165 183.717 -29.607 171.294 -41.2676 157.238C-78.4415 113.688 -31.0676 83.972 21.0093 53.4275C22.342 52.6317 23.6779 51.8353 25.0152 51.038C67.1696 25.9078 110.719 -0.0540123 99.688 -35Z"
        fill="#1F1755"
        fillOpacity="0.5"
      />
      <path
        d="M129.186 196H76.4252C57.7098 183.725 40.4778 171.309 30.2873 157.262C-2.00253 113.712 33.3608 83.9955 74.7781 53.451C76.8422 51.9049 78.922 50.3567 81.0071 48.8044C113.85 24.3549 148.036 -1.09515 143.862 -35H203.143C209.398 -0.663113 172.05 25.0029 136.067 49.7319C134.221 51.0004 132.379 52.2664 130.546 53.531C85.5863 83.9955 46.2349 113.712 80.3911 157.243C91.1448 171.297 109.437 183.718 129.186 196Z"
        fill="#1F1755"
        fillOpacity="0.5"
      />
      <path
        d="M247.48 196H185.997C165.368 183.751 146.167 171.358 134.954 157.342C99.2008 113.792 142.522 84.0755 191.024 53.531C192.659 52.4823 194.3 51.4327 195.943 50.3817L195.945 50.3805L195.949 50.3782C234.995 25.4056 275.341 -0.398788 266.933 -35H335.034C346.065 -0.0540085 302.516 25.9078 260.361 51.038C259.024 51.8353 257.688 52.6317 256.356 53.4275C204.279 83.972 156.905 113.688 194.079 157.238C205.739 171.294 225.925 183.717 247.48 196Z"
        fill="#1F1755"
        fillOpacity="0.5"
      />
      <path
        d="M364.102 196H302.619C281.989 183.751 262.789 171.358 251.576 157.342C215.822 113.792 259.143 84.0755 307.645 53.531C309.274 52.4861 310.91 51.4404 312.547 50.3931L312.552 50.3897L312.554 50.3885L312.563 50.3828L312.569 50.3793L312.57 50.3782C351.616 25.4055 391.963 -0.3988 383.555 -35H451.656C462.687 -0.0540085 419.137 25.9078 376.983 51.038C375.646 51.8353 374.31 52.6317 372.977 53.4275C320.9 83.972 273.526 113.688 310.7 157.238C322.361 171.294 342.546 183.717 364.102 196Z"
        fill="#1F1755"
        fillOpacity="0.5"
      />
      <path
        d="M501.001 196H448.24C429.525 183.725 412.293 171.309 402.103 157.262C369.813 113.712 405.176 83.9955 446.593 53.451C448.657 51.9049 450.737 50.3567 452.822 48.8044C485.665 24.3549 519.852 -1.09514 515.677 -35H574.958C581.213 -0.663136 543.866 25.0029 507.882 49.7318C506.036 51.0003 504.194 52.2664 502.361 53.531C457.401 83.9955 418.05 113.712 452.206 157.243C462.96 171.297 481.253 183.718 501.001 196Z"
        fill="#1F1755"
        fillOpacity="0.5"
      />
      <path
        d="M587 175.958V196H557.812C537.183 183.751 517.982 171.358 506.769 157.342C471.016 113.792 514.337 84.0755 562.839 53.531C564.476 52.4812 566.119 51.4304 567.764 50.3782C574.216 46.2518 580.703 42.1028 587 37.8951V79.4183C556.089 101.846 539.21 125.978 565.894 157.238C571.322 163.782 578.598 169.972 587 175.958Z"
        fill="#1F1755"
        fillOpacity="0.5"
      />
    </svg>
  );
}
